import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { getProjectRevenueReport } from "~/modules/project/api/projectRevenueReport/projectRevenueReportApiDispatchers.ts";

export const projectRevenueReportQueries = {
	baseKey: ["project-revenue-report"],
	byProject: (projectId: string) =>
		queryOptions({
			queryKey: [...projectRevenueReportQueries.baseKey, "project", projectId],
			queryFn: () => getProjectRevenueReport(projectId).then(getDataFromResponse),
		}),
};
